/**
 * Small "part of a weekly series" chip for the staff booking detail header
 * (migration 0096). Links to the series page.
 */
import { Repeat } from 'lucide-react';
import { Link } from 'react-router-dom';

export function SeriesChip({ seriesId }: { seriesId: string }) {
  return (
    <Link
      to={`/recurring-series/${seriesId}`}
      className="inline-flex items-center gap-1.5 rounded-full bg-primary/10 px-2.5 py-1 text-[11px] font-medium leading-none text-primary ring-hairline press"
      title="Open the weekly series this visit belongs to"
    >
      <Repeat className="size-3" strokeWidth={1.75} aria-hidden />
      Weekly series
    </Link>
  );
}
